import ViewBase from "../view-base.view";
import goodMovementModel from "../../models/posm/goods-movement.model";
import SingleSelectComponent from "../../components/single-select/single-select.component";
export function POSMGoodsHierachy() {
  ViewBase.call(this)
  return {
    oninit: () => {

    },
    view: ({ attrs: { hierachyLabels, onSelect, MOVEMENT_OPTIONS, movementDetail } }) => {
      return [
        m('.col.position-relative', [
          m('label.form-label', this.getText(hierachyLabels[0][1], hierachyLabels[0][0])),
          m('.input-group',
            m(SingleSelectComponent, {
              popoverAttrs: { class: 'posm-filters' },
              items: MOVEMENT_OPTIONS.main,
              selectedItem: movementDetail.main,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, 'main', 'MAIN', 'GOODS_TYPE', 'goodsType')
              },
            }),
          ),
        ]),
        m('.col.position-relative', [
          m('label.form-label', this.getText(hierachyLabels[1][1], hierachyLabels[1][0])),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.goodsType.findIndex((item) => { return item.code == movementDetail.goodsType.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: MOVEMENT_OPTIONS.goodsType.length != 0,
              items: MOVEMENT_OPTIONS.goodsType,
              selectedItem: movementDetail.goodsType,
              checkmark: true,
              filterable: true,

              onSelect: (s) => {
                onSelect(s, 'goodsType', 'GOODS_TYPE', 'DIVISION', 'division')
              },
            }),


          )
        ]),


        m('.col.position-relative', [
          m('label.form-label', this.getText(hierachyLabels[2][1], hierachyLabels[2][0])),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.division.findIndex((item) => { return item.code == movementDetail.division.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: MOVEMENT_OPTIONS.division.length != 0,
              items: MOVEMENT_OPTIONS.division,
              selectedItem: movementDetail.division,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, 'division', 'DIVISION', 'MODEL', 'model')
              },
            }),

          ),
        ]),

        m('.col.position-relative', [
          m('label.form-label', this.getText(hierachyLabels[3][1], hierachyLabels[3][0])),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.model.findIndex((item) => { return item.code == movementDetail.model.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: MOVEMENT_OPTIONS.model.length != 0,
              items: MOVEMENT_OPTIONS.model,
              selectedItem: movementDetail.model,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, 'model', 'MODEL', 'BASIC_MODEL', 'basicModel')
              },
            }),

          ),
        ]),

        m('.col.position-relative', [
          m('label.form-label', this.getText(hierachyLabels[4][1], hierachyLabels[4][0])),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.basicModel.findIndex((item) => { return item.code == movementDetail.basicModel.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: MOVEMENT_OPTIONS.basicModel.length != 0,
              items: MOVEMENT_OPTIONS.basicModel,
              selectedItem: movementDetail.basicModel,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, 'basicModel', 'BASIC_MODEL');
              },
            })
          ),
        ]),
        this.getBaseViews(),
      ]
    }
  }
}